(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fragrance-quiz"] && !Shopify.designMode) return;
  try {
    
  const quiz = document.querySelector('[data-fragrance-quiz]');
  if (quiz) {
    const form = quiz.querySelector('[data-quiz-form]');
    const results = quiz.querySelector('[data-quiz-results]');
    const steps = Array.from(quiz.querySelectorAll('[data-quiz-step]'));
    const backButton = quiz.querySelector('[data-quiz-back]');
    const nextButton = quiz.querySelector('[data-quiz-next]');
    const submitButton = quiz.querySelector('[data-quiz-submit]');
    const progressFill = quiz.querySelector('[data-quiz-progress-fill]');
    const progressLabel = quiz.querySelector('[data-quiz-progress-label]');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const questionCount = steps.length - 1;
    let current = 0;

    const isStepAnswered = (index) => {
      const radios = steps[index].querySelectorAll('input[type="radio"]');
      return radios.length === 0 || Array.from(radios).some((radio) => radio.checked);
    };

    const renderStep = () => {
      steps.forEach((step, index) => {
        step.hidden = index !== current;
      });

      const isLast = current === steps.length - 1;
      backButton.hidden = current === 0;
      nextButton.hidden = isLast;
      submitButton.hidden = !isLast;
      nextButton.disabled = !isStepAnswered(current);

      progressFill.style.width = `${((current + 1) / steps.length) * 100}%`;
      progressLabel.textContent = isLast
        ? 'Almost done'
        : `Question ${current + 1} of ${questionCount}`;

      const activeStep = steps[current];
      if (!prefersReducedMotion) {
        activeStep.classList.remove('fragrance-quiz__step--enter');
        void activeStep.offsetWidth;
        activeStep.classList.add('fragrance-quiz__step--enter');
      }
      activeStep.focus();
    };

    quiz.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        nextButton.disabled = !isStepAnswered(current);
      });
    });

    nextButton?.addEventListener('click', () => {
      if (current < steps.length - 1 && isStepAnswered(current)) {
        current += 1;
        renderStep();
      }
    });

    backButton?.addEventListener('click', () => {
      if (current > 0) {
        current -= 1;
        renderStep();
      }
    });

    renderStep();

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(form);
      const answers = {
        scent: data.get('scent'),
        occasion: data.get('occasion'),
        intensity: data.get('intensity')
      };
      results.querySelectorAll('[data-quiz-group]').forEach((group) => {
        group.hidden = group.dataset.quizGroup !== answers.scent;
      });
      results.hidden = false;
      results.focus();
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (data.get('consent') === 'yes') {
        localStorage.setItem('koa_fragrance_quiz', JSON.stringify(answers));
        window._learnq = window._learnq || [];
        window._learnq.push(['track', 'Fragrance Quiz Completed', answers]);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
